import { mdiEyeOutline } from "@mdi/js"
import { spaNavigate } from "../../../../../../../../_shared/_logic/navigation"
import type { TableRowAction } from "@kontextwerk/web-sdk/core/layout/table"

export default function buildRowActions({
  workOrderId,
  organizationId,
  organizationSlug = null,
  organizationPathSegment = null,
}: {
  workOrderId: string | null | undefined
  organizationId: string
  organizationSlug?: string | null
  organizationPathSegment?: string | null
}): TableRowAction[] {
  const openWorkOrder = () => {
    const pathSegment = organizationPathSegment ?? organizationSlug ?? organizationId

    if (!pathSegment || !workOrderId) return

    spaNavigate(
      `/organizations/${encodeURIComponent(pathSegment)}/work-orders/${encodeURIComponent(workOrderId)}`,
      { noSearchParam: false },
    )
  }
  const actions: TableRowAction[] = []

  actions.push({
    id: "action-0",

    label: "Auftrag öffnen",
    onClick: () => openWorkOrder(),
    icon: mdiEyeOutline,
    disabled: !workOrderId,
    tooltip: "Auftrag öffnen",
    testId: `open-work-order-${workOrderId}`,
  })

  return actions
}
